"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var server_1 = require("./server");
var index_vue_1 = require("./index.vue");
var install = function (app) {
    index_vue_1.default.TUIServer = TUISearch.server;
    app.component(TUISearch.name, index_vue_1.default);
};
var plugin = function (TUICore) {
    TUISearch.server = new server_1.default(TUICore);
    TUICore.component(TUISearch.name, TUISearch);
    return TUISearch;
};
var TUISearch = {
    name: 'TUISearch',
    component: index_vue_1.default,
    server: server_1.default,
    install: install,
    plugin: plugin,
};
exports.default = TUISearch;
